/**
 * AllocationsPage — operator route for browsing and managing per-tenant
 * capability allocations across the platform.
 *
 * WQ-230 (Phase 4.9 α4). Renders the cross-tenant AllocationsTab.
 */

import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AllocationsTab from '../components/ai/AllocationsTab';

const AllocationsPage: React.FC = () => {
  const { user } = useAuth();
  const userEmail = (user as { email?: string } | null)?.email || '';

  return (
    <div className="page-container" style={{ padding: '24px' }}>
      <header style={{ marginBottom: '20px' }}>
        <h1 style={{ marginBottom: '4px' }}>AI Allocations</h1>
        <p style={{ color: 'var(--text-secondary)', marginTop: 0 }}>
          Per-tenant capability allocations and quota usage. Operator surface.
        </p>
      </header>
      <AllocationsTab currentUserEmail={userEmail} />
    </div>
  );
};

export default AllocationsPage;
